export const customerUsers = [
    "Contabilidade",
    "ContabilidadeTrial",
    "ContabilidadeTrialPro",
    "Contabil",
    "Comercial",
    "Fiscal",
    "Pessoal",
    "Financeiro",
    "Gestor",
    "Pessoal e Fiscal",
    "Empresa"
];

export const accountingUsers = [
    "Contabilidade",
    "Contabil",
    "Comercial",
    "Fiscal",
    "Pessoal",
    "Financeiro",
    "Gestor",
    "Pessoal e Fiscal"
];

export const accoutingTrialUsers = [
    "ContabilidadeTrial",
    "ContabilidadeTrialPro"
];

export const nucontersUsers = [
    "Super",
    "Sucesso",
    "NuHacker",
    "ChampionsLeads",
    "Heads"
];

export const AnonymousUser = {
    name: "Anônimo",
    email: "anonimo.permanente@nucont.com"
}; //"anonimo@nucont.com";
